import { IPoi, IEventPoiagg } from "~/interfaces";
import { node } from "~/util/dom";
import { createPOIListImage } from "./poilistimage";
import FirmStarsReview from "~/review/stars-review";
import { IReviewItem, IReview } from "~/review/interfaces";
import { getReviewConf } from "~/util/review";
import { _ } from "~/i18n";
import FirmReviewStarsPicker from "~/review/stars-picker";

interface IRatingCardOptions {
	className?: string;
	onStarsClick?: (data: { review: IReview; myReview: IReviewItem }) => void;
	onStructuredRating?: (data: { review: IReview; rating: number; source: string; id: number | string; }) => void;
	onPOIChoice?: (event: MouseEvent) => void;
	poi: IPoi | IEventPoiagg;
	onPOIClick?: (event: MouseEvent) => void;
	logObj?: object;
	activeRequest?: boolean;
	myReview?: IReviewItem;
	starWidth?: number;
	starOffset?: number;
}

export function createRatingCard({
	className = "",
	onStarsClick = null,
	onStructuredRating = null,
	onPOIChoice = null,
	poi,
	onPOIClick = null,
	logObj = {},
	activeRequest,
	myReview,
	starWidth = 30,
	starOffset = 10,
}: IRatingCardOptions): HTMLDivElement {
	// kontajner
	const container = node("div", { className: `ui-rating-card ${onPOIClick ? "ui-rating-card--clickable" : ""} ${className}` });

	// info o POIi
	const poiInfo = node("div", { className: `ui-rating-card__poiInfo` });

	container.appendChild(poiInfo);
	onPOIClick && poiInfo.addEventListener("click", onPOIClick);
	// ikona
	const icon = createPOIListImage(poi, true);

	poiInfo.appendChild(icon);
	// texty
	const text = node("div", { className: `ui-rating-card__texts` });

	poiInfo.appendChild(text);
	text.appendChild(node("h3", { className: "ui-rating-card__title", innerHTML: poi.titleVars.titleSmartMain, title: poi.titleVars.titleSmartMain }));
	if (poi.typeName) {
		text.appendChild(node("p", { className: "ui-rating-card__category", innerHTML: poi.typeName, title: poi.typeName }));
	}
	text.appendChild(node("p", { className: "ui-rating-card__address", innerHTML: poi.titleVars.locationMain1, title: poi.titleVars.locationMain1 }));

	// tlacitko na vyber jineho POIe
	if (onPOIChoice) {
		const buttonPOIChoice = node("button", { className: `ui-rating-card__poiChoice ${icon.classList.contains("small") ? "" : "adjust"}`, innerHTML: _("mymap.reviews.suggestPOIChoiceButton") });

		buttonPOIChoice.setAttribute("data-log-ignore", "true");
		buttonPOIChoice.addEventListener("click", function poiChoiceClick(event: MouseEvent) {
			event.stopPropagation();
			onPOIChoice(event);
		});
		container.appendChild(buttonPOIChoice);
	}

	// hvezdy
	if (myReview) {
		const starsPicker = new FirmReviewStarsPicker({
			starWidth,
			starOffset,
			// FIXME: tohle nejak poresit, az bude cas
			// @ts-ignore
			clickCb: onStarsClick,
		});

		starsPicker.percent = myReview.rating;
		container.appendChild(starsPicker.container);
	} else if (onStarsClick) {
		const data = getReviewConf(poi);
		const starsPicker = new FirmStarsReview({
			starWidth,
			starOffset,
			data,
			showPopupCb: onStarsClick,
			onStructuredRating,
			logObj,
			activeRequest,
			...data.myReview ? { rating: data.myReview.rating } : {},
		});

		container.appendChild(starsPicker.container);
	}

	return container;
}
